export default class BaseChallengeSubmissionService {
	constructor(challengeService, userProfileService) {
		this._challengeService = challengeService;
		this._userProfileService = userProfileService;
	}
}
